// Libraries
import React, { useState } from 'react';
import { Form, Input, Button, Typography } from 'antd';

import { useMessagerManager } from '../../../../contexts/MessagerManager/Provider';
import { useTheme } from '~/contexts/ThemeContext';
import UpdateChat from '~/services/calls/messager/chat/update';
import DropdownIcon from '../../components/DropdownIcon';
import VIEWS from '../../../../constants/views';

import * as S from './style';

const { Text } = Typography;

export default function EditChat() {
  const { theme } = useTheme();
  const { institutionId, setView, setChats, selectedChat, setSelectedChat } =
    useMessagerManager();

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState({ name: selectedChat.name });

  async function onFinish() {
    setLoading(true);

    const chatId = selectedChat.id;

    const chat = formValues;

    const response = await UpdateChat({ chat, chatId, institutionId });

    if (response.success) {
      setChats((currentChats) => {
        return currentChats.map((currentChat) => {
          if (currentChat.id !== chatId) return currentChat;

          const newChat = { ...currentChat, name: chat.name };

          setSelectedChat(newChat);
          return newChat;
        });
      });

      setView(VIEWS.MY_CHATS);
    }

    setLoading(false);
  }

  const onChangeInput = (event) => {
    const { name, value } = event.target;

    setFormValues({ ...formValues, [name]: value });
  };

  const formItemStyle = {
    marginBottom: 12,
  };

  const textStyle = {
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '100%',
    color: theme.color.white,
  };

  return (
    <S.Container>
      <S.Header style={{ backgroundColor: theme.color.primary }}>
        <S.Stack>
          <Text style={{ color: theme.color.secondaryDark }}>Editando:</Text>
          <Text style={textStyle}>{selectedChat.name}</Text>
        </S.Stack>

        <DropdownIcon />
      </S.Header>

      <Form style={{ padding: '16px' }} layout="vertical" autoComplete="off">
        <Form.Item
          style={formItemStyle}
          label="Nome do grupo"
          rules={[{ required: true, message: 'Coloque o nome do grupo' }]}
        >
          <Input
            size="default"
            name="name"
            value={formValues.name}
            onChange={onChangeInput}
          />
        </Form.Item>

        <Form.Item style={{ marginTop: 12 }}>
          <Button
            loading={loading}
            onClick={onFinish}
            size="default"
            type="primary"
          >
            Editando
          </Button>
        </Form.Item>
      </Form>
    </S.Container>
  );
}
